/** Mirrors MadCloud.Domain.Status.StatusIncidentType. */
export enum StatusIncidentType {
  Unplanned = 0,
  ScheduledMaintenance = 1
}